export default class TestimonialsBlock {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        const loadMoreButton = document.querySelector('#load__more');
        const container = document.querySelector('#testimonials__items');
        const skeleton = document.querySelector('#testimonials__skeleton');
        if (loadMoreButton) {
            loadMoreButton.onclick = () => {
                const currentPosts = document.querySelectorAll('.testimonials__item');
                let ids = [];
                currentPosts.forEach((item) => {
                    ids.push(item.dataset.id);
                });
                skeleton.classList.add('active');
                this.fetchPosts(ids).then(response => {
                    if (response['block'] === '') {
                        loadMoreButton.classList.add('hidden');
                    } else {
                        container.innerHTML += response['block'];
                    }
                    skeleton.classList.remove('active');
                }).catch(error => {
                    skeleton.classList.remove('active');
                });
            }
        }
    }

    async fetchPosts(currentPosts, id = null) {
        const origin = window.location.origin;
        let url = `${origin}/wp-json/royalhomes/v1/testimonials-block/`;
        var postData = {};
        if (currentPosts !== null) {
            postData['exemptions'] = currentPosts;
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData),
        });

        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson ? await response.json() : null;

        if (!response.ok) {
            const message = `An error has occurred fetching the models: ${response.status}`;
            throw new Error(message);
        }
        return data;
    }
}